import _extends from "@babel/runtime/helpers/extends";

/** @jsx jsx */
import { jsx } from '@emotion/react';
import { components } from 'react-select';
import Spinner from '@atlaskit/spinner';
import SelectClearIcon from '@atlaskit/icon/glyph/select-clear';
import DownIcon from '@atlaskit/icon/glyph/chevron-down';
export var ClearIndicator = function ClearIndicator(props) {
  return jsx(components.ClearIndicator, props, jsx(SelectClearIcon, {
    size: "small",
    label: "clear"
  }));
};
export var DropdownIndicator = function DropdownIndicator(props) {
  return jsx(components.DropdownIndicator, props, jsx(DownIcon, {
    label: "open"
  }));
};
export var LoadingIndicator = function LoadingIndicator(props) {
  return jsx("div", _extends({
    css: props.getStyles('loadingIndicator', props)
  }, props.innerProps), jsx(Spinner, {
    size: "small"
  }));
};